var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 7.66016H13.333M15.333 7.66016H13.333M13.333 7.66016V5.66016M13.333 7.66016V9.66016",
    stroke: "#CCCCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 14.3275V13.6608C0.666992 11.0835 2.75633 8.99414 5.33366 8.99414V8.99414C7.91099 8.99414 10.0003 11.0835 10.0003 13.6608V14.3275",
    stroke: "#CCCCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33366 8.99349C6.80642 8.99349 8.00033 7.79958 8.00033 6.32682C8.00033 4.85406 6.80642 3.66016 5.33366 3.66016C3.8609 3.66016 2.66699 4.85406 2.66699 6.32682C2.66699 7.79958 3.8609 8.99349 5.33366 8.99349Z",
    stroke: "#CCCCCC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.0965dbad64234d03d56070b108dc0928.svg";
export { ForwardRef as ReactComponent };